import styled from 'styled-components'

export const CopyableContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  min-width: 0;
`

export const CopyableText = styled.span`
  color: #262626;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`

export const CopyableLink = styled.a`
  color: #1677ff;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;

  &:hover {
    color: #4096ff;
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid #1677ff;
    outline-offset: 2px;
    border-radius: 2px;
  }
`

export const CopyIcon = styled.button<{ $copied?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => (props.$copied ? '#52c41a' : '#8c8c8c')};
  font-size: 12px;
  flex-shrink: 0;
  transition: color 0.2s;
  background: transparent;
  border: 0;
  padding: 0;
  line-height: 0;

  &:hover {
    color: ${(props) => (props.$copied ? '#52c41a' : '#00a0a8')};
  }

  &:focus-visible {
    outline: 2px solid #00a0a8;
    outline-offset: 2px;
    border-radius: 2px;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const EmptyValue = styled.span`
  color: #262626;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`
